import {
	CreateRegistrationQuestion,
	RegistrationQuestion
} from "../types/working-model";
import { Post, Get, Put } from "./helpers";

export const GetRegistrationQuestions = async (channel: number, token: string): Promise<any> => {
	return Get(`/v3/admin/events/registration-questions/${channel}`, token, {}, true)
		.then(async res => {
			return await res.json();
		});
};

export const SaveRegistrationQuestion = async (question: RegistrationQuestion, token: string): Promise<any> => {
	return Put(`/v3/admin/events/registration-questions/${question.registration_question}`, token, question, false, true)
		.then(async res => {
			return await res.json();
		});
};

export function CreateRegQuestion(
	question: CreateRegistrationQuestion,
	token: string
): Promise<any> {
	return Post("/v3/admin/events/registration-questions", token, question);
}
